import styled from 'styled-components';

import { purple1 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { mediaUp, rem } from 'approot/shared/style';
import { SLIDES_WIDTH } from 'approot/activity-builder/activity-builder-slides.style';
import {
  ACTIVITY_BUILDER_CANVAS_Z_INDEX,
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_HEADER_TOOLBAR_Z_INDEX,
} from 'approot/activity-builder/activity-builder.constants';
import { flexColumnCss } from 'approot/shared/styles/flex.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';

export const DRAFT_BANNER_HEIGHT_SMALL = 104;
export const DRAFT_BANNER_HEIGHT_LARGE = 56;

type ActivityBuilderDraftDrawerStatusProps = {
  $isDrawerActive: boolean;
};
export const ActivityBuilderDraftCanvas = styled.div<ActivityBuilderDraftDrawerStatusProps>`
  position: fixed;
  padding-top: ${rem(spacing24)};
  left: ${rem(SLIDES_WIDTH)};
  margin: 0;
  top: ${rem(LAYOUT_HEADER_HEIGHT + DRAFT_BANNER_HEIGHT_SMALL)};
  bottom: 0;
  right: 0;
  overflow: scroll;
  z-index: ${ACTIVITY_BUILDER_CANVAS_Z_INDEX};

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    right: ${({ $isDrawerActive }) =>
      rem($isDrawerActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
  }

  ${mediaUp.sm`
    top: ${rem(LAYOUT_HEADER_HEIGHT + DRAFT_BANNER_HEIGHT_LARGE)};
  `}
`;

export const ActivityBuilderDraftRestoreBanner = styled.div<ActivityBuilderDraftDrawerStatusProps>`
  ${flexColumnCss}
  width: 100%;
  background-color: ${purple1};
  text-align: center;
  position: fixed;
  z-index: ${ACTIVITY_BUILDER_HEADER_TOOLBAR_Z_INDEX};
  padding: ${rem(spacing8)};
  gap: ${rem(spacing8)};

  ${mediaUp.sm`
    flex-direction: row;
    gap: ${rem(spacing16)};
  `}

  button {
    width: 100%;

    ${mediaUp.sm`
      width: auto;
    `}
  }

  ${({ $isDrawerActive }) =>
    $isDrawerActive &&
    `
    padding-right: ${rem(ACTIVITY_BUILDER_DRAWER_WIDTH)};
  `}
`;
